export type PassengerAgeCategory = 'adult' | 'children' | 'infant';

export function passengerAgeCategory(
  index: number,
  counts: { adult: number; children: number }
): PassengerAgeCategory {
  return index < counts.adult
    ? 'adult'
    : index < counts.adult + counts.children
      ? 'children'
      : 'infant';
}

function parseLocalDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
    ? date
    : null;
}

export function matchesPassengerAge(
  birthValue: string,
  flightValue: string,
  category: PassengerAgeCategory
): boolean {
  const birth = parseLocalDate(birthValue);
  const flight = parseLocalDate(flightValue);
  if (!birth || !flight || birth > flight) return false;
  let age = flight.getFullYear() - birth.getFullYear();
  if (
    flight.getMonth() < birth.getMonth() ||
    (flight.getMonth() === birth.getMonth() && flight.getDate() < birth.getDate())
  )
    age--;
  return category === 'adult'
    ? age >= 12
    : category === 'children'
      ? age >= 2 && age < 12
      : age < 2;
}

export function passengerBirthRange(
  flightValue: string,
  category: PassengerAgeCategory
): { min: Date; max: Date } {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const flight = parseLocalDate(flightValue);
  if (!flight) return {min: new Date(1900, 0, 1), max: today};
  const yearsBefore = (years: number): Date => {
    const year = flight.getFullYear() - years;
    const month = flight.getMonth();
    return new Date(
      year,
      month,
      Math.min(flight.getDate(), new Date(year, month + 1, 0).getDate())
    );
  };
  let min =
    category === 'adult' ? new Date(1900, 0, 1) : yearsBefore(category === 'children' ? 12 : 2);
  if (category !== 'adult') min.setDate(min.getDate() + 1);
  const limit =
    category === 'adult' ? yearsBefore(12) : category === 'children' ? yearsBefore(2) : flight;
  return {min, max: limit < today ? limit : today};
}
